<template>
    <div>
        <div class="feed-body" v-if="!search">
            <!-- <div class="text-area">
                <div class="label">Текст заметки:</div>
                <MobileInput v-if="$vuetify.breakpoint.xsOnly" :value="''" @input="setNotice($event, feeds[0]._id)" :key="feed_key" :click="addNoticeHandle"/>
                <div v-else>
                    <div class="relative">
                        <TTextArea class="new-notice mt-2" autofocus :value="''" @ctrlEnter="addNoticeHandle" @input="setNotice($event, feeds[0]._id)" :key="feed_key +'_key'" rows="6"/>
                        <div class="absolute position-button button_add_edit_notice pointer" @click="addNoticeHandle">Добавить</div>
                    </div>
                </div>
            </div> -->
            <div class="notices-container" v-if="feeds.length">           
                <div class="flex-center py-2 roboto-normal-18 clr-black-9d pointer">
                    <div @click="toggleAll" v-show="feeds[0] && feeds[0].notices.length">
                        <div class="left ml-2" v-if="$vuetify.breakpoint.smAndUp">Показать:</div>
                        <div v-if="noticesAll" class="left ml-11 mr-4">Активные ({{noticesActiveLength}})</div>
                        <div v-else class="left ml-11 mr-4">Все ({{feeds[0] && feeds[0].notices.length}})</div>
                        <img v-if="!noticesAll" class="left mt-n1" height="29px" src="@/assets/images/components/arrow-up.svg">
                        <img v-if="noticesAll"  class="left mt-n1" height="29px" src="@/assets/images/components/arrow-down.svg">
                    </div>
                    <v-text-field
                        v-if="feeds[0].notices.length"
                        :prepend-icon="'mdi-magnify'"
                        single-line
                        clear-icon="mdi-close-circle"
                        clearable
                        type="text"
                        v-model="feedsSearch"
                        class="ml-8 search-desktop"
                    ></v-text-field> 
                </div>           
                <v-row class="notices" v-if="$vuetify.breakpoint.smAndUp">
                    <v-col class="notices-grid notices-height" :class="{xl:$vuetify.breakpoint.xlOnly}">
                        <div class="mx-5 mb-9" v-for="(notice, i) in filteredNotices" :key="notice._id"> 
                            <ItemCard 
                                :notice="notice"
                                @click="pickedNotice(notice)"
                            />   
                            <!-- <Notice
                                class="content-color"
                                :id="`notice-id-${notice._id}`"
                                :notice="notice"
                                draggable="true"
                                @dragstart.native="startDragNotice($event, notice)"
                                :low="noticesQuality.filter[i]"
                                @click.native="pickedNotice(notice)"
                            /> -->
                        </div>
                    </v-col>
                    <v-col class="ml-5"> 
                        <h4>Создать заметку:</h4>
                        <NoticeBody :notice="picked_notice" v-if="feeds[0].notices.length && picked_notice"/>
                        <TTextArea v-model="noticeBody" rows="6" v-else/>
                        <div class="left ml-10 mt-4">
                            <div class="button_add_edit_notice px-2 pointer" @click="pickedNotice(picked_notice)" v-if="feeds[0].notices.length && picked_notice">Создать новую</div>
                        </div>
                        <div class="right mr-10 mt-4">
                            <DeleteItem class="px-2" @deleteItem="deleteNotice()" :notice="true" v-if="feeds[0].notices.length && picked_notice"/>
                        </div>
                    </v-col>
                </v-row>
                <v-col v-else>
                    <div> 
                        <h4>Создать заметку:</h4>
                        <NoticeBody :notice="picked_notice" v-if="feeds[0].notices.length && picked_notice"/>
                        <TTextArea v-model="noticeBody" v-else/>
                        <div class="button_add_edit_notice my-5 pointer" @click="pickedNotice(picked_notice)" v-if="feeds[0].notices.length && picked_notice">Создать новую</div>
                        <div class="mb-2">
                            <DeleteItem @deleteItem="deleteNotice()" :notice="true" v-if="feeds[0].notices.length && picked_notice"/>
                        </div>
                    </div>
                    <div class="panel-mobile" v-for="(notice, i) in filteredNotices" :key="notice._id">
                        <ItemCard class="mt-6" :notice="notice" @click="pickedNotice(notice)"/>
                    </div>
                </v-col>
            </div>          
        </div>
        <div class="search" v-if="$vuetify.breakpoint.xs && search">
            <div class="flex-center mt-8" @click="toPrevPage()">
                <img class="ml-7" src="@/assets/images/components/arrow-left-blue.svg">
                <div class="roboto-normal-18 clr-blue ml-2">Назад</div>
            </div>
            <SearchMobile/>
        </div>
    </div>
</template>

<script>
	import {mapActions, mapGetters, mapMutations} from 'vuex'
    import Notice from './Notice.vue'
    import MobileInput from '../misc/MobileInput';
    import SearchMobile from '../header/SearchMobile'
    import { debounce, cloneDeep } from 'lodash'
    import { elemInViewport } from '../../helpers';
    import NoticeBody from './NoticeBody.vue'
    import TTextArea from '../misc/TTextArea'
    import ItemCard from '@/components/main/ItemCard.vue'
    import DeleteItem from '@/components/popups/DeleteItem'

    export default {
        name: 'FeedBody',
        props: ['feed'],
        components: {
            Notice,
            MobileInput,
            SearchMobile,
            NoticeBody,
            TTextArea,
            ItemCard,
            DeleteItem
        },
        data() {
            return {
                feed_key: 0,
                newNotices: {},
                feedsSearch: '',
                noticesAll: false,
                noticesQualityInterval: 0,
                noticesQuality: [],
                search: false,
            }
        },
        computed:{
            ...mapGetters(['current_feed', 'feeds', 'picked_notice']),
            feedBody:{
                get(){
                    return this.feed.body || ""
                },
                set: debounce(function(newVal) {                    
                    this.editFeed({_id: this.feed._id, text: newVal})
                }, 450)
            },
            noticeBody: {
                get(){
                    return this.picked_notice ? this.picked_notice.body : ""
                },
                set: debounce(async function(newVal) {
                        await this.addNotice({feed_id: this.feeds[0]._id, notice:{body: newVal}})
                        await this.editNotice({feed_id: this.feeds[0]._id, notice_id: this.feeds[0].notices[this.feeds[0].notices.length - 1]._id, text: newVal})
                        await this.pickedNotice(this.feeds[0].notices[this.feeds[0].notices.length - 1])
                }, 450)
            },            
            notices(){
                const notices = this.feeds[0] ? [...this.feeds[0].notices] : []
                const unsorted = this.noticesAll ? notices : notices.filter(el => !el.completedInFeed)
                return unsorted.sort((a,b) => {
                    return +new Date(a.createdAt) < +new Date(b.createdAt) ? 1 : -1
                })
            },
            noticesActiveLength(){
                return this.notices && this.notices.filter(el => !el.completedInFeed).length 
            },
            filteredNotices() {
                return this.feedsSearch ? this.notices.filter(el => el.body.toLowerCase().includes(this.feedsSearch.toLowerCase())) : this.notices
            }               
        },            
        methods: {
            ...mapActions(['addNotice', 'editFeed', 'editNotice', 'addFeed', 'delNotice']),
            ...mapMutations(["TOGGLE_PICKED_NOTICE"]),
            addNoticeHandle(){
                this.addNotice({feed_id: this.feeds[0]._id, notice:{body: this.newNotices[this.feeds[0]._id]}})
                this.setNotice("", this.feeds[0]._id)
                this.feed_key++
            },
            toggleAll(){
                this.noticesAll = !this.noticesAll
            },    
            setNotice(content, id){
                this.$set(this.newNotices, id, content)
            }, 
            startDragNotice(evt, item) {
                evt.dataTransfer.dropEffect = 'move'
                evt.dataTransfer.effectAllowed = 'move'
                evt.dataTransfer.setData('dragNotice', JSON.stringify(item))
            },
            pickedNotice(notice) {
                this.TOGGLE_PICKED_NOTICE(notice)
            },
            toPrevPage() {
                this.search = false
            },
            async deleteNotice() {
                if (this.picked_notice) {
                    await this.delNotice({feed_id: this.feeds[0]._id, notice_id: this.picked_notice._id})
                    await this.pickedNotice(this.picked_notice)
                }
            }
        },
        mounted() {
            this.$root.$on('toCurrentNotice', (notice) => {
                this.pickedNotice(notice)  
            })
            this.$root.$on('search', () => { 
                this.search = true         
            })
            this.$root.$on('selectElementMenu', () => { 
                this.toPrevPage()
            })
            // const noticeId = this.$router.currentRoute.hash
            // if (noticeId) this.$nextTick(()=> this.$vuetify.goTo(noticeId))
            // this.noticesQuality = this.filteredNotices.map(() => true)
            // this.noticesQualityInterval = setInterval(() => {
            //     this.filteredNotices.forEach((notice, i) => {
            //         const el = document.getElementById('notice-id-' + notice._id) 
            //         this.$set(this.noticesQuality, i, !elemInViewport(el))
            //     })
            // }, 500)
        },
        destroyed(){
            clearInterval(this.noticesQualityInterval)
        }
}
</script>

<style lang="scss" scoped>
.feed-body {
    margin: 14px 2% 0;
    .position-button {
        bottom: 20px;
        right: 20px;
    }
    .notices {
        display: flex;
        flex-wrap: nowrap;
        .notices-grid {
            background: #F8F8F8;
            display: grid;
            grid-template-columns: repeat(2, 50%);
            &.notices-height {
                max-height: calc(100vh - 260px);
                overflow-x: hidden;
                overflow-y: auto;
            }
            &.notices-height::-webkit-scrollbar {
                width: 9px;
                background-color: #FAFAFA;
            }
            &.notices-height::-webkit-scrollbar-thumb {
                background-color: #EDEDED;
            }
            &.xl {
                grid-template-columns: repeat(3, 33%);
            }

        }
        .content-color  {
            background: #FFFFFF;
        }
    }
    // .notices >
    //     .panel-odd:nth-child(odd),
    //     .panel-even:nth-child(even),
    //     .panel-mobile:nth-child(odd) {
    //         background:#edf7f2;
    //         box-sizing: border-box;
    //         border-radius: 7px;
    // }
}
.v-input {
    max-width:30%;
}
</style>

<style lang="scss">
.feed-body{
    .notices-container{
        .theme--light.v-text-field>.v-input__control>.v-input__slot:before {
            border-color: rgba(0,0,0,.02);
        }
    }
    .col{
        padding: 12px 1px !important;
    }
}

</style>